import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import markup from "ulysses/controls/expressionpicker.html";

ko.bindingHandlers.expressionpicker = {
    "init": function(elt, va, allbindings, model, context) {
        $(elt).html(markup);
        var expression = ko.unwrap(va());
        var modeloptions = allbindings().modeloptions;
        var expression_model = {
            "expression": expression.expression,
            "kind": expression.kind,
            "is_nfield": ko.pureComputed(function() { return ko.unwrap(expression.kind) == "nfield"; }),
            "is_field": ko.pureComputed(function() { return ko.unwrap(expression.kind) == "field"; }),
            "is_const": ko.pureComputed(function() { return ko.unwrap(expression.kind) == "const"; }),
            "is_script": ko.pureComputed(function() { return ko.unwrap(expression.kind) == "script"; }),
            "setNField": function() { expression_model.kind("nfield"); },
            "setField": function() { expression_model.kind("field"); },
            "setScript": function() { expression_model.kind("script"); },
            "setConst": function() { expression_model.kind("const"); },
            "showField": ko.pureComputed(function() {
                return ko.unwrap((ko.unwrap(allbindings().modeloptions) || {}).allow_fields) === true;
            }),
            "showNField": ko.pureComputed(function() {
                return ko.unwrap((ko.unwrap(allbindings().modeloptions) || {}).allow_nfield) === true;
            }),
            "showScript": ko.pureComputed(function() {
                return ko.unwrap((ko.unwrap(allbindings().modeloptions) || {}).allow_script) === true;
            }),
            "showConst": ko.pureComputed(function() {
                return ko.unwrap((ko.unwrap(allbindings().modeloptions) || {}).allow_constant) === true;
            }),
            "modeloptions": modeloptions
        };
        var childContext = context.createChildContext(expression_model);
        ko.applyBindingsToDescendants(childContext, elt);
        return {"controlsDescendantBindings":true};
    },
    "update": function(elt, va, allbindings) {
        
    }
};
